<template>
	<div class="app-container">

		<!-- 顶部栏 -->
		<div class="topbar">
			<div>
				<el-input v-model="searchValue" placeholder="昵称，姓、名、医院、职务、头衔、擅长" size="small"
					prefix-icon="el-icon-search" class="search-input" @keyup.enter.native="search()" />
				<el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
					@click.stop="search()">
					搜索
				</el-button>
				<el-select clearable style="padding-left: 20px;" v-model="curCertificateStatusOption"
					@change="curCertificateStatusOptionChange">
					<el-option v-for="item in certificateStatusOptions" :key="item" :value="item"
						:label="item | certificateStatusTransform"></el-option>
				</el-select>
			</div>
<!--			<el-button type="primary" size="small" @click="addExpertDlg = true">添加专家</el-button>-->
		</div>
		<!-- 内容 -->
		<el-table ref="userCertificationList" v-loading="loading" :data="userCertificationList"
			:header-cell-style="{ background: '#F5F7FA' }" style="width: 100%; margin-bottom: 20px">
			<!-- NOTE 接口没有返回响应数据，暂时注释 -->
			<el-table-column type="expand" align="center">
		  <template slot-scope="scope">
			<div >
<!--			  <div class="detail-left">-->
<!--				<span> 单位: {{ scope.row.Organization }}</span>-->
<!--				<span> 科室: {{ scope.row.Subject }}</span>-->
<!--				<span> 头衔: {{ scope.row.JobGrade }}</span>-->
<!--				<span> 职务: {{ scope.row.Job }}</span>-->
<!--				<span> 地址: {{ scope.row.Address }}</span>-->
<!--			  </div>-->


      <div>
              <span>
				  证件类型:
				  {{ scope.row.certificateType | certificateTypeTransform }}
              </span>
      </div>
        <div style="display: flex;align-items: flex-start;padding-top: 20px">
              <span> 证件照: </span>
              <el-image
                  style="width: 160px; height: 120px"
                  :src="config.RESOURCES + scope.row.certificatePic"
                  :preview-src-list="[
					config.RESOURCES + scope.row.certificatePic,
				  ]"
              />

			  </div>
			</div>
		  </template>
		</el-table-column>
			<el-table-column label="ID" prop="userID" width="100" align="center" />
			<el-table-column label="头像" align="center">
				<template slot-scope="scope">
					<el-image style="width: 40px; height: 40px" :src="
				scope.row.avatar ? config.RESOURCES + scope.row.avatar : ''
			  " />
				</template>
			</el-table-column>
			<el-table-column label="昵称" prop="nickname" align="center" show-overflow-tooltip />
			<!-- NOTE 接口没有返回响应数据，暂时注释 -->
			<!-- <el-table-column label="姓名" align="center" show-overflow-tooltip>
		  <template slot-scope="scope">
			{{ scope.row.firstName + scope.row.LastName }}
		  </template>
		</el-table-column> -->
			<el-table-column label="性别" align="center">
				<template slot-scope="scope">
					{{ scope.row.sex | sexTransform }}
				</template>
			</el-table-column>
			<el-table-column label="手机号" prop="mobilePhone" align="center" />
			<el-table-column label="是否专家" prop="isUltraExpert" align="center">
				<template slot-scope="scope">
					{{ scope.row.isUltraExpert ? "是":"否" }}
				</template>
			</el-table-column>
			<el-table-column label="当前状态" prop="status" align="center">
				<template slot-scope="scope">
					<el-tag size="medium" :type="
	scope.row.certificateStatus === 0
	? 'warning'
	: scope.row.certificateStatus === 1
	? 'info'
	: scope.row.certificateStatus === 2
	? 'success'
	: 'danger'
	">
						{{
				scope.row.certificateStatus |certificateStatusTransform
			  }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="200" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="success" :disabled="scope.row.certificateStatus === 2"
						@click.stop="setUserCertificate(scope.row, 2)">
						通过认证
					</el-button>
					<el-button size="small" type="danger" :disabled="scope.row.certificateStatus === 3"
						@click.stop="setUserCertificate(scope.row, 3)">
						驳回认证
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination v-show="totalCount > pageSize" background :total="totalCount" :page-size="pageSize"
			:current-page="currentPage" @current-change="currentChange" />

		<!-- 添加专家 -->
		<search-user-dlg :visiable="addExpertDlg" dlgTitle="添加专家" @dlg-close="addExpertDlg = false">
			<template #default="scope">
				<el-button :disabled="scope.entity.isUltraExpert" size="small" type="primary"
					@click="setExpert(scope.entity)">
					设为专家
				</el-button>
			</template>
		</search-user-dlg>
	</div>
</template>

<script>
	import {
		getUserCertificationList,
		getAllUserList,
		setUserCertificate,
	} from "@/api/userManagement";

	import {
		isVaild
	} from "@/utils/validate"

	import searchUserDlg from "@/components/searchUserDlg/searchUserDlg"

	import {
		printObj
	} from "@/utils/debug"

	export default {

		data() {
			return {
				activeIndex: "0", // 当前索引
				loading: false, // 加载开关
				searchValue: "", // 搜索内容
				totalCount: 0, // 列表总数
				pageSize: 10, // 单页条数
				currentPage: 1, // 当前页码
				userCertificationList: [], // 所有待认证用户列表
				form: {},
				formLabelWidth: "70px",
				certificateStatusOptions: [0, 1, 2, 3],
				curCertificateStatusOption: "",
				// 添加专家相关
				addExpertDlg: false,

			};
		},
		created() {
			this.refreshCurrentList();
		},
		components: {
			searchUserDlg
		},
		methods: {
			/**
			 * 刷新列表
			 */
			refreshCurrentList() {
				this.getUserCertificationList();
			},
			/**
			 * 切换 tab
			 */
			handleClick() {
				this.currentPage = 1;
				this.searchValue = "";
				this.refreshCurrentList();
			},
			/**
			 * 搜索
			 */
			search() {
				this.currentPage = 1;
				this.refreshCurrentList();
			},
			/**
			 * 重置
			 */
			reset() {
				this.searchValue = "";
				this.refreshCurrentList();
			},
			/**
			 * 翻页
			 *
			 * @param {number} currentPage 当前页码
			 */
			currentChange(currentPage) {
				this.currentPage = currentPage;
				this.refreshCurrentList();
			},

			/**
			 * 获取所有未认证用户列表
			 */
			getUserCertificationList() {
				this.loading = true;
				const params = {
					sortName: "",
					sortOrder: "",
					pageNumber: this.currentPage,
					pageSize: this.pageSize,
					keyWord: this.searchValue,
				};
				if (isVaild(this.curCertificateStatusOption)) {
					params.where = [{
						"field": "certificateStatus",
						"value": this.curCertificateStatusOption,
						"op": "equal"
					}]
				}
				getUserCertificationList(params).then((res) => {
					this.userCertificationList = res.data.rows;
					this.totalCount = res.data.total;
					this.utils.stopLoading(this);
				});
			},
			/**
			 * 设置用户认证状态
			 *
			 * @param {object} row 所选对象信息
			 * @param {number} status 2-通过验证 3-驳回验证
			 */
			setUserCertificate(row, status) {
				const params = {
					userID: row.userID,
					certificateStatus: status,
				};
				setUserCertificate(params).then((res) => {
					this.refreshCurrentList();
					this.$store.dispatch("newMsg/setExpertAuthenticationNo")
					console.log(res);
				});
			},
			/**
			 * 过滤处理
			 */
			curCertificateStatusOptionChange() {
				this.currentPage = 1
				this.refreshCurrentList()
			},

			/**
			 * 通过用户认证
			 */
			certified(index, row) {
				this.$confirm("是否通过该用户认证", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						this.$message({
							type: "success",
							message: "通过认证成功!",
						});
					})
					.catch(() => {
						this.$message("取消操作");
					});
			},
			/**
			 * 驳回用户认证
			 */
			rejectCertification(index, row) {
				this.$confirm("是否驳回该用户认证", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						row.status = "已驳回";
						this.$message({
							type: "success",
							message: "驳回认证成功!",
						});
					})
					.catch(() => {
						this.$message("取消操作");
					});
			},
			/**
			 * 设置专家
			 * @param {Object} item
			 */
			setExpert(item) {
				printObj(item)
			}
		},
	};
</script>

<style>
</style>
